const STOCK_LOT_TARGET_KIND = "stockLot";

export default STOCK_LOT_TARGET_KIND;
